// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2OA7K"};